export default class ItemStore {
    id?: number;
    item_uid?: string;
    out_of_stock?: boolean;
    store_id?: number;
    snooze_start_date?: string;
    snooze_end_date?: string;

    constructor(init?: Partial<ItemStore>) {
        Object.assign(this, init);
    }
}
